/**
 * Event types that can generate notifications. Mirror of the backend enum in
 * apps/lidz_back/src/types/pubsub-events.ts (EVENT_NOTIFICATION_TYPES).
 */
export const NOTIFICATION_EVENT_TYPES = [
  'message_with_ai_disabled',
  'client_assigned',
  'client_stage_priority',
  'call_permission_granted',
  'client_stage_reservation',
  'client_stage_promise',
  'client_meeting_scheduled',
] as const;

export type NotificationEventType = (typeof NOTIFICATION_EVENT_TYPES)[number];

export const NOTIFICATION_EVENT_TYPE_LABELS: Record<NotificationEventType, string> = {
  message_with_ai_disabled: 'Mensaje de cliente con IA desactivada',
  client_assigned: 'Cliente nuevo asignado',
  client_stage_priority: 'Cliente pasa a prioridad',
  call_permission_granted: 'Cliente acepta ser llamado',
  client_stage_reservation: 'Nueva reserva',
  client_stage_promise: 'Nueva promesa',
  client_meeting_scheduled: 'Visita agendada',
};

export interface DomainConfig {
  roles: string[];
}

export interface DefaultConfig {
  minScore: number;
  considerAssignment: boolean;
}

export interface IncludeUsersConfig {
  all: number[];
  byProjectUser: Record<string, number[]>;
  byEventType: Partial<Record<NotificationEventType, number[]>>;
}

export interface NotificationConfigValue {
  domains: {
    alert: DomainConfig | null;
    question: DomainConfig | null;
    task: DomainConfig | null;
    // Event is a pure on/off switch: roles never affect event delivery
    // (recipients are the client's assigned user + includeUsers.byEventType).
    // null = disabled; { roles: [] } = enabled. Enabled by default.
    event: DomainConfig | null;
  };
  configs: {
    default: DefaultConfig;
    byProjects: Record<string, DefaultConfig>;
  };
  includeUsers: IncludeUsersConfig;
}

export const DEFAULT_NOTIFICATION_CONFIG: NotificationConfigValue = {
  configs: {
    default: {
      minScore: 0,
      considerAssignment: false,
    },
    byProjects: {},
  },
  domains: {
    task: { roles: [] },
    alert: { roles: [] },
    question: { roles: [] },
    event: { roles: [] },
  },
  includeUsers: {
    all: [],
    byProjectUser: {},
    byEventType: {},
  },
};
